import { Component } from '../Component'
import { element } from '../CustomElement'
import { icons } from '../../icons/Icons'

interface ToastElementProps extends JSX.HTMLProps {
    message?: string
}

// Public Definitions -------------------------------------------------------->

@element('flipp-warning-toast')
export class WarningToast extends Component<ToastElementProps, any> {
    render() {
        return (
            <div class="inner" role="alert" flex-horizontal>
                <div class="text">
                    <span class="sign">{icons.warn}</span>
                    <span>
                        Please accept the Terms of Use and Privacy Policy in
                        order to continue
                    </span>
                </div>
                <button class="close" onClick={this.hide}>
                    <span flex-vertical>{icons.x}</span>
                </button>
            </div>
        )
    }

    public hide = (e?: MouseEvent) => {
        if (e) {
            e.preventDefault()
        }
        this.classList.remove('show')
    }

    public show = (e?: MouseEvent) => {
        if (e) {
            e.preventDefault()
        }
        this.classList.add('show')
    }
}
